@if ((isReadonlyWrapper$ | async); as wrapper) {
  @if (!wrapper.isReadonly) {
    <div class="mt-3 flex">
      <sc-search-member [members]="filteredMembers$ | async"
                        (filter)="filterMembers($event)"
                        (selectItem)="addContentEditor($event)"
                        class="flex-grow-1"
                        emptyMessage="No members found"
                        i18n-emptyMessage>
      </sc-search-member>
    </div>
  }
  <p-table [scTableSettings]="tableSettings"
           class="mt-3">
    @if (!wrapper.isReadonly; as rowData) {
      <ng-template pTemplate="row-actions"
                   let-rowData>
        <i class="fas fa-trash"
           (click)="deleteContentEditor(rowData.memberId)"
           pTooltip="Click to delete content editor"
           tooltipPosition="top"
           i18n-pTooltip></i>
      </ng-template>
    }
  </p-table>
}